import { useExternalStock } from "./hooks/useExternalStock";

export const ExternalStockWidget = ({
  permanentDomain,
  sku,
  country,
  ownStock,
}: {
  permanentDomain: string;
  sku: string;
  country: string;
  ownStock: number;
}) => {
  const { textColor, message } = useExternalStock({ sku, permanentDomain, country, ownStock });

  if (message.length === 0) return null;

  return (
    <div>
      <div>
        {message.map((m) => (
          <p style={{ color: textColor || "#000000", fontWeight: "500" }}>{m}</p>
        ))}
      </div>
    </div>
  );
};
